import { initialListPaginationMeta } from "utils/helpers/pagination";

import { RegistrationForm, RegistrationState } from "../types";

export const initialRegistrationForm: RegistrationForm = {
  driverCabinType: "",
  tire: "",
  suspensionType: "",
  weight: "",
  axlesMeasure: "",
  lowerLimit: "",
  upperLimit: "",
  frontLoad: "",
  rearAxlesMeasure: "",
  notes: "",
  dhType: "",
  bodyType: "",
};

export const initialRegistrationMeta = initialListPaginationMeta;

export const initialState: RegistrationState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialRegistrationMeta,
  error: null,
  driverCabinFilter: "ALL",
  axlesMeasureFilter: "ALL",
  frontLoadFilter: "ALL",
  rearAxlesMeasureFilter: "ALL",
  weightFilter: "ALL",
  tireFilter: "ALL",
  dhTypeFilter: "ALL",
  bodyTypeFilter: "ALL",
  isAddModalOpen: false,
  form: initialRegistrationForm,
};
